/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import { deleteGuidanceMarketPrompt } from 'src/shared/domain/membership/action/membershipActions';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';

import MarketBasePromptCardDumb from './MarketBasePromptCardDumb';

type Props = {
  icon?: React.Node,
  route: string,
  guidanceLabel: string,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (state: Object, ownProps: Props): Object => {
  const { guidanceLabel } = ownProps;

  return {
    membership: getMembership(state),
    guidanceLabel,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { guidanceLabel }: Props,
): Object => {
  const { membership } = stateProps;

  return {
    ...stateProps,
    handleDismiss() {
      trackGAEvent('Market', 'Dismiss prompt', guidanceLabel);

      dispatch(deleteGuidanceMarketPrompt(membership, guidanceLabel));
    },
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(MarketBasePromptCardDumb);
